export default "__VITE_ASSET__4ea47fb1__"